/**
 * A phone number as pasted, minus what came along with it. Copying a number
 * from an email (Outlook on a phone especially) brings the link behind it
 * ("0412 345 678<tel:0412345678>"), HTML tags or entities, and invisible
 * direction marks; left in, the digits double up and the SMS goes nowhere.
 * Keeps digits, a leading +, and the spaces, brackets, dots and dashes people
 * write numbers with. Mirrors src/contacts/phone.ts, which cleans the number again on save.
 */
export function cleanPhone(raw: string): string {
  return raw
    .replace(/<[^>]*>?/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&#(\d+);/g, (_, n: string) => String.fromCharCode(Number(n)))
    .replace(/&#x([0-9a-f]+);/gi, (_, n: string) => String.fromCharCode(parseInt(n, 16)))
    .replace(/&[a-z]+;/gi, '')
    .replace(/\b(tel|callto|sms):/gi, '')
    .replace(/[^\d+()\-. ]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/(?!^)\+/g, '');
}

/**
 * For a phone field's onChange: what the office types is left exactly as is
 * (so a trailing space survives mid-number), and only a value carrying
 * something no number has, as a paste from an email does, is cleaned.
 */
export const phoneField = (value: string): string =>
  /[^\d+()\-. ]/.test(value) ? cleanPhone(value) : value;
